export default (state = { type: "info", message: "", open:false }, action) => {
  switch (action.type) {
    case "SET_GLOBAL_ALERT":
      return Object.assign({}, state, {
        type: action.globalAlert.type,
        message: action.globalAlert.message,
        open: action.globalAlert.open,
      });
      break;
    default:
      return state;
  }
};
